<template>

    <div class="container">
                <div class="row justify-content-center col-xl-7 col-lg-8 bg-white">
            <!-- Text -->
            <div class="w-100 px-5">
             <!-- /FORM -->
        <div key="pendency" v-show="pendency">
            
            <h2 v-if="isXXL" class="mt-7 mb-5 font-weight-normal" >Ops! Esqueceu de pagar a fatura?</h2>
            <h4 v-else  class="mt-5 mb-5 font-weight-normal">Ops! Esqueceu de pagar a fatura?</h4>
              
            <!-- FORM -->
            <!-- TODO: o evento submit por algum motivo não funcionou aqui... -->
            <b-row>
             <b-form ref="formLogin" class="col-sm-12 mx-auto">
                <block-ui :loading="pendencyLoading"></block-ui>
                <div class="text-muted">
                    <b-alert :show="!permiteExtender" variant="secondary">
                        <h4 class="alert-heading">Você já utilizou o acesso extra de 3 dias!</h4>
                        <p>Para continuar utilizando o Segfy, é necessário realizar o pagamento dos débitos listados abaixo.</p>
                        
                    </b-alert>

                    <b-alert :show="permiteExtender" variant="secondary">
                        <p>Fique tranquilo(a), confira abaixo sua{{ plural }} fatura{{ plural }} em aberto, vamos liberar o seu acesso por mais 3 dias até que suas pendências sejam quitadas.</p>
                        <b-table :items="items" :fields="fields">
                            <template slot="dataVencimento" slot-scope="data">
                                {{data.item.dataVencimento | toDate}}
                            </template>
                            <template slot="valor" slot-scope="data">
                                {{data.item.valor | toCurrency}}
                            </template>
                            <!-- <template slot="linkBoleto" slot-scope="data">
                                <a :href="data.item.linkBoleto" target="_blank" class="btn btn-sm btn-primary">Ver cobrança</a>
                            </template> -->
                        </b-table>
                        <div class="mt-2">
                            <b-btn variant="success" type="submit" size="md" class="btn-auth btn-block" :state="dataState.unblockButton" @click.prevent="unblock()">Ver fatura{{ plural }} e liberar o acesso por 3 dias</b-btn>
                        </div>
                        <div class="mt-1">
                            <p style="font-style:italic;font-size: 10px;">Evite novo bloqueio, realize o pagamento antes dos 3 dias.</p>
                        </div>
                    </b-alert>
                </div>
            </b-form>
            </b-row>
        </div>
            </div>
            <!-- /.Text -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<script>
import { normalLogin, unblockUser } from './methods.js'
import { mapActions } from 'vuex'
import { getUrlParameter } from '@/extensions/utils.js'
import BlockUI from '../common/blockUI'

export default {
    name: 'authentication-login',
    metaInfo: {
        title: 'LoginSSO'
    },
    data: () => ({
        credentials: {
            email: '',
            password: ''
        },
        loading: true,
          dataState: {
            button: true,
            unblockButton: true,
            assinaturaLogin: null
        },
        tokenPendency: '',
        pendency: false,
        permiteExtender: false,
        fields: [
          { key: 'dataVencimento', label: 'Vencimento' },
          { key: 'valor', label: 'Valor' }
        //   { key: 'linkBoleto', label: '', class: 'coluna-boleto' }
        ],
        items: [],
        loginLoading: false,
        pendencyLoading: false,
        icon: 'fa-eye-slash'    
        }),
    components: {
        'block-ui': BlockUI
    },
    computed: {
            plural () {
                return this.items.length > 1 ? 's ' : ''
            }
        },
methods: {
unblock: function () {
this.dataState.unblockButton = false
this.pendencyLoading = true
    return unblockUser({ token: this.$store.state.auth.hash })
    .then(resp => {
        // Abre as cobranças pendentes do cliente
        this.items.forEach(item => {
            if (item.MetodoPagamento === 'Boleto' || item.MetodoPagamento === 'PIX') {
                window.open(item.linkBoleto, '_blank')
            }
        })

        this.loginSSO()
    })
    .catch(err => {
        this.dataState.button = true
        this.pendencyLoading = false

        if (err) {
            window.Vue.$noty.error(err.message)
        }
    })
},
...mapActions({
updateUserInfo: 'auth/updateUserInfo',
updateAsLoggedIn: 'auth/updateAsLoggedIn',
setHash: 'auth/setHash'
}),
loginSSO: function () {
    return normalLogin(this.credentials)
        .then(resp => {
            this.updateUserInfo(resp.data)
            this.updateAsLoggedIn()
            window.Vue.hub.connectionFaye.start()
            this.loading = false
            if (process.env.VUE_APP_FAYE !== 'local') {
                window.Vue.hub.connectionFaye.pub('logoff', 'login' + window.Vue.hub.connectionFaye.uid)
                window.Vue.hub.connectionFaye.sub('logoff', (arg1) => {}, true, false)
            }

            const redirectParam = getUrlParameter('rd')

            if (redirectParam === 'c') {
                this.$router.push('/multicalculo/orcamento-redirect#navr=156c2c8a')
                return
            }

            // Conseguimos logar! Vamos primeiro salvar isso na store
            // E redirecionamos o user para a tela /home
            this.$router.push('/home')
        })
        .catch(err => {
            this.loading = true
            this.dataState.button = true
            this.loginLoading = false

            if (err) {
                if (err.code === 1) {
                    this.setHash(err.data.token)
                    this.tokenPendency = err.data
                    this.items = this.tokenPendency.cobranca.listaCobranca
                    this.permiteExtender = this.tokenPendency.cobranca.permiteExtender
                    this.pendency = true
                } else {
                    if (err.code !== undefined && err.message && err.message.length > 0) {
                        this.$router.push({ path: '/400', query: { loginvalid: err.message[0] } })
                        window.Vue.$noty.error(err.message)
                    }
                }
            }                    
            // this.manageErrors(err.errors)
        })
    }
},
mounted: function () {
        return this.loginSSO()
}    
}
</script>
